import { PayloadAction } from '@reduxjs/toolkit';
import { InvoicesStore, InvoiceType } from '../types';

export const setInvoicesData = (state: InvoicesStore, action: PayloadAction<InvoiceType[]>) => {
  state.list = action.payload;
};
